ParentDialogHandler = App.loadClass 'portal::handlers/convert/Parent_Dialog_Handler'

class exports.Delivery_Dialog_Handler extends ParentDialogHandler

    init: () ->
        @reportAjax = 'backend/portal/delivery/get-data'
        @layoutUrl = 'backend/portal/delivery/load-layout-dialog'
        @saveUrl = 'backend/portal/delivery/save'
        super()

    afterLoadLayout: (selector, response) ->
        @warehouses = response.data
        super(selector, response)

    ###
    Datatables fnRowCallback used to build the datatable report
    ###
    rowCallback: (row, data) ->
        $(row).addClass 'row-fluid actual-row tr-no-bottom-margin'
        $('td:eq(0)', row).html("<span class='span12 labels-vertical-pad' name='contract'>#{data[0]}</span>")
        $('td:eq(1)', row).html("<span class='span12 labels-vertical-pad' name='field' title='#{data[1]}'>#{data[1]}</span>")
        $('td:eq(1)', row).addClass 'convert-field-name'

        $('td:eq(2)', row).html("<input type='text' name='actual_acres' disabled='disabled' class='span12' value='#{data[2]}'></input>")
        $('td:eq(2)', row).addClass 'normal-line'

        $('td:eq(3)', row).html("<input type='text' name='actual_brand' disabled='disabled' class='span12' value='#{data[3]}'></input>")
        $('td:eq(4)', row).html("<input type='text' name='actual_date'  disabled='disabled' class='txt-actual-date span12' value='#{data[4]}'></input>")
        $('td:eq(5)', row).html("<input type='text' name='days'  disabled='disabled' class='span12 days' value='#{data[5]}'></input>")
        $('td:eq(6)', row).html("<div class='input-append'><input type='text' name='days_adj' class='txt-days span8' data-orig='#{data[6]}' value='#{data[6]}'><div class='add-on'> +/- </div></div>")
        $('td:eq(7)', row).html("<input type='text' name='hrvst_date' disabled='disabled' class='hrvst_date span12' data-orig='#{data[7]}' value='#{data[7]}'></input>")
        $('td:eq(8)', row).html("<select name='warehouse' class='span12 warehouse' data-orig='#{data[8]}'></select>")

        # Populate warehouse options
        $('td:eq(8)', row).find('.warehouse').append("<option value=''>Select...</option>")

        for key, wh of @warehouses
            if data[8] is wh.id
                selected = "selected='selected'"
            else
                selected = ''
            $('td:eq(8)', row).find('.warehouse').append("<option " + selected + " value='" + wh.id + "'>" + wh.name + "</option>")

    saveStub: () ->
        @dialog.find('.errorDiv').hide()
        @dialog.find('.mfvalidate-invalid').removeClass('mfvalidate-invalid')

        doSave = true
        @saveData['toUpdate'] = []

        for row in @dialog.find('.actual-row')
            row = $(row)
            fcid = row.attr('id')
            days = row.find('.txt-days').val()
            warehouse = row.find('.warehouse').val()

            if days? and days % 1 isnt 0
                # highlight the erronous date in red
                row.find('.txt-days').addClass('mfvalidate-invalid')
                # don't continue saving
                doSave = false
            else
                # everything seems valid, add the row to the data which should be saved
                @saveData['toUpdate'].push { 'fc_id': fcid, 'days': days, 'warehouse': warehouse }

        if doSave
            for elem in @dialog.find('[data-orig]')
                $(elem).data('orig', $(elem).val())
            @saveData['toUpdate'] = JSON.stringify @saveData['toUpdate']
            @save('Saving...')
        else
            @dialog.find('.errorDiv').html('There were errors saving your data. Please correct the highlighted values and try again.').show()
